/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, OnInit, ViewContainerRef, inject } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { LoadingSpinnerService } from "src/app/shared/service/loading-spinner.service";
import { DataServiceServiceProfile } from "../services/profile-data-service.service";
import { TranslationService } from "src/app/shared/service/translation.service";
import { AppConstants } from "src/app/shared/constants/constants";
import { ToastService, ToastType } from "src/app/shared/service/toast.service";
import { SharingDataService } from "src/app/shared/service/sharing-data.service";
import { CreateEditProfileComponent } from "../create-edit-profile/create-edit-profile.component";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";
import { ToastModule } from "src/app/components/toast/toast.module";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { InviteMemberFormComponent } from "../invite-member-form/invite-member-form.component";

@Component({
  selector: "app-alias-group-members",
  templateUrl: "./alias-group-members.component.html",
  styleUrls: ["./alias-group-members.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    SharedModule,
    ToastModule,
    NgxSkeletonLoaderModule,
    InviteMemberFormComponent,
    CreateEditProfileComponent,
  ],
})
export class AliasGroupMembersComponent implements OnInit {
  public viewContainerRef: ViewContainerRef = inject(ViewContainerRef);
  private readonly dataService: DataServiceServiceProfile = inject(DataServiceServiceProfile);
  private readonly loadingSpinner: LoadingSpinnerService = inject(LoadingSpinnerService);
  private readonly translationService: TranslationService = inject(TranslationService);
  private readonly toastService: ToastService = inject(ToastService);
  private readonly _sharingDataService: SharingDataService = inject(SharingDataService);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _destroyRef = inject(DestroyRef);
  isModalOpen: boolean = false;
  showToast: boolean = false;
  isToasterShown: boolean = false;
  toastMessage: string = "";
  toastType: any = 0;
  position: any;
  leftPosition: any;
  members: any;
  groupName: any;
  translationData: any;
  profileName: any;
  enableEditProfile: boolean = false;
  profileDetails: any = null;
  isIconInfoShown: boolean = false;

  isMenuClicked: boolean = false;
  showIndex: any;
  dp: any = "assets/images/profile.svg";
  linkout: any = "assets/images/alias/resize.svg";
  info: any = "assets/images/alias/information.svg";
  componentName: string = "alias-group-members";
  isCloseModal: boolean = false;
  closeButtonTitle: string = AppConstants.COMMON_BUTTON_LABELS.CANCEL;
  saveButtonTitle: string = "Invite";
  editProfileClicked: boolean = false;
  public buttonNames: any = AppConstants.COMMON_BUTTON_LABELS;

  ngOnInit(): void {
    this.groupName = localStorage.getItem("aliasGroupName");
    this.profileName = localStorage.getItem("profileName");
    this.getMemberList();
    this.toastService.toastDetails
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((status: any) => {
        this.showToast = status?.isShown;
        this.toastMessage = status?.message;
        this.toastType = status?.toastType;
        this.position = status?.position;
        this.leftPosition = status?.leftPosition;
        this._cdr.markForCheck();
      });
  }

  public getMemberList() {
    this.dataService.getMemberList(this.groupName).subscribe((res: any) => {
      const data = res.body;
      if (data) {
        this.members = data.members;
        this.profileDetails = data.profile;
        this.loadingSpinner.hide();
        if (this.isToasterShown) {
          const toastMessage = "BP_PM_SUCCESS_ADD";
          this.showToaster(toastMessage);
        }
        localStorage.setItem("profileImage", data.profile.profileImageUrl);
      }
      this.enableEditProfile = true;
      this._cdr.markForCheck();
    });
  }

  showToaster(toastMessage: string) {
    this.showToast = true;
    this.toastService.show(ToastType.Success, `${toastMessage}`, "1%", "40%");
    setTimeout(() => {
      this.showToast = false;
      this.isToasterShown = false;
      this._cdr.markForCheck();
    }, AppConstants.MIN_TIME_TOASTER);
  }

  menuClicked(i: any) {
    this.isMenuClicked = !this.isMenuClicked;
    this.showIndex = i;
    this._cdr.markForCheck();
  }

  closeDialog() {
    this.isMenuClicked = false;
    this._cdr.markForCheck();
  }

  addMember() {
    this.isModalOpen = true;
    this._cdr.markForCheck();
  }

  editProfile() {
    this.editProfileClicked = true;
    this._cdr.markForCheck();
  }

  cancelClicked(event: any) {
    if (event) {
      this.editProfileClicked = false;
      this._cdr.markForCheck();
    }
  }

  closeModal() {
    this.isModalOpen = false;
    this._cdr.markForCheck();
  }

  saveModal() {
    this.isToasterShown = true;
    this.getMemberList();
  }

  updateProfile(event: any) {
    this.profileDetails = {
      ...this.profileDetails,
      profileImageUrl: event.profileImageUrl,
      profileName: event.profileName,
      profileDescription: event.profileDescription,
      businessWebsite: event.businessWebsite,
    };
    localStorage.setItem("profileImage", event.profileImageUrl);
    this._sharingDataService.setProfileChanged(true);
    this.loadingSpinner.hide();
    this._cdr.markForCheck();
    this.showToaster("BP_PM_UPDATE_SUCCESS");
  }

}
